import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "@/services/dashboardService";

export function useDashboardSystem() {
  return useQuery({ queryKey: ["dashboard", "system"], queryFn: dashboardService.getSystem });
}
